export const cn = {
    new_question: {
        placeholder: '输入关于技术的问题，获取技术知识，技术信息和方案解答...',
        ask_new_question: '询问',
    },
}

export const en = {
    new_question: {
        placeholder: 'Ask technology questions to focus your research',
        ask_new_question: 'Ask',
    },
}

export const jp = {
    new_question: {
        placeholder: '技術に関する質問を入力して、技術知識、情報、ソリューションを得ましょう...',
        ask_new_question: '質問',
    },
}

export const tw = {
    new_question: {
        placeholder: '輸入關於技術的問題，獲取技術知識，技術信息和方案解答...',
        ask_new_question: '詢問',
    },
}
